import React, { FC, HTMLAttributes } from 'react';
import { TextInput } from '../layout/TextInput';

type Props = {
  edit: boolean
  onValueChange: any
  onEnterEdit: Function
  onSave: Function
  value: string
} & HTMLAttributes<HTMLInputElement>

const NameClusterInput: FC<Props> = ({ edit, value, onValueChange, onEnterEdit, onSave }) => (
  <TextInput
    className='NameClusterInput'
    edit={edit}
    value={value}
    onChange={onValueChange}
    onEditIconClick={() => {
      onEnterEdit()
    }}
    onSaveIconClick={(value: string) => {
      onSave(value)
    }}
    style={{
      height: "25px",
      placeItems: "center",
      width: "100%",
      color: "#f44b48"
    }}
  />
)
export default NameClusterInput;